import { h, Component } from 'preact';
import cx from 'classnames';
import style from './style';
import WidthConstrain from '../../widthconstrain';
import { LinkEventList } from '../../linkevent';
import LogoIcon from '../../logoicon';
import Copyright from '../../copyright';
import { withConfig } from '../../../config';
import { TrackingProvider, trackingProvider, DIMENSION } from '@cube/track';

function linksInColumns(links = [], columnCount) {
	let r = links.reduce((acc, link) => {
		if (acc[acc.length-1].length >= columnCount) {
			acc.push([]);
		}
		acc[acc.length-1].push(link);
		return acc;
	}, [[]]);
	return r;
}

@trackingProvider({
	[DIMENSION.componentpath]: 'DesktopFooter'
})
export class Footer extends Component {

	static defaultProps = {
		theme: 'light',
		linkColumnMaxItems: 4,
		showLogo: true
	}

	render({ class: cls, theme, links, altLinks, affiliateLinks, logo, showLogo, linkColumnMaxItems, portalStaticOrigin }) {
		let columns = linksInColumns(links, linkColumnMaxItems);
		return (
			<div class={cx(style.footer, style[theme], cls)}>
				<WidthConstrain>
					{showLogo && (
						<div class={cx('col-2', style.logoRow)}>
							<LogoIcon
								theme={theme}
								size="lg"
								link={logo}
								class={style.logo}
								portalStaticOrigin={portalStaticOrigin}
							/>
						</div>
					)}

					<div class={cx('col', style.linkColumns)}>
						{ columns.map((col, i) => (
							<TrackingProvider {...{
								[DIMENSION.componentpath]: 'Links'
							}}
							>
								<LinkEventList links={col} listType="ul" positionIndex={linkColumnMaxItems * i} />
							</TrackingProvider>
						))}
						<TrackingProvider {...{
							[DIMENSION.componentpath]: 'AffiliateLinks'
						}}
						>
							<LinkEventList links={affiliateLinks} theme={theme} class={style.affiliateColumn} />
						</TrackingProvider>
					</div>

					<div class="col">
						<hr class={cx(style.divider, style[theme])} />
					</div>


					<div class={cx('col', style.bottomLinks)}>
						<Copyright />
						<TrackingProvider {...{
							[DIMENSION.componentpath]: 'AltLinks'
						}}
						>
							<LinkEventList links={altLinks} theme={theme} listType="ul" />
						</TrackingProvider>
					</div>
				</WidthConstrain>
			</div>
		);
	}
}

const FooterConfig = withConfig([

	'portalStaticOrigin',

	'headerWidget.desktop.footer.theme',
	'headerWidget.footer.theme',
	'headerWidget.theme',

	'headerWidget.desktop.footer.links',
	'headerWidget.footer.links',

	'headerWidget.desktop.footer.altLinks',
	'headerWidget.footer.altLinks',

	'headerWidget.desktop.footer.affiliateLinks',
	'headerWidget.footer.affiliateLinks',

	'headerWidget.desktop.footer.linkColumnMaxItems',
	'headerWidget.footer.linkColumnMaxItems',

	'headerWidget.desktop.logo',
	'headerWidget.logo',

	'headerWidget.desktop.footer.showLogo',
	'headerWidget.footer.showLogo'

])(Footer);

export default FooterConfig;
